// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticleByline_root__MDhII","link":"ArticleByline_link__2gL7T"};